'use strict';

/**
 * Converts a formatted currency string into a numeric amount.
 * @param {string|number} value - Currency value (e.g. "$12.34") or numeric input.
 * @returns {number} Parsed numeric value, or 0 when parsing fails.
 */
function parseAmount(value) {
    return Number(String(value || '').replace(/[^0-9.-]/g, '')) || 0;
}

/**
 * Formats a numeric amount using the currency symbol inferred from a template string.
 * @param {number} amount - Amount to format.
 * @param {string} template - Formatted currency template used to infer symbol.
 * @returns {string} Formatted amount with two decimal places.
 */
function formatAmount(amount, template) {
    var symbol = String(template || '').replace(/[0-9.,\-\s]/g, '') || '$';
    return symbol + amount.toFixed(2);
}

/**
 * Estimated billed total after store credit and gift cards, clamped at zero.
 * @param {Object} totals - Totals model from server
 * @returns {string} Formatted amount for display
 */
function getAdjustedGrandTotalDisplay(totals) {
    if (!totals) {
        return '';
    }
    var totalTemplate = totals.grandTotalAfterGCApplied || totals.grandTotal;
    var grandTotalAmount = parseAmount(totalTemplate);
    var adjustedGrandTotalAmount = Math.max(grandTotalAmount, 0);
    return formatAmount(adjustedGrandTotalAmount, totalTemplate);
}

/**
 * Recreates the total placeholder inside the place order buttons when it is gone.
 * Third-party scripts relabel the button by overwriting its text (int_paypal does
 * this on the billing Edit link and for Venmo), which discards the total element.
 */
function ensurePlaceOrderTotalElement() {
    $('.place-order, .express-place-order').each(function () {
        var $button = $(this);
        if ($button.find('.place-order-total').length) {
            return;
        }

        var label = $button.text().trim().split('|')[0].trim();
        $button.text(label ? label + ' | ' : '');
        $button.append($('<span class="place-order-total" />'));
    });
}

/**
 * Syncs PLACE ORDER button label with checkout summary total.
 * @param {Object} totals - Totals model from server
 */
function updatePlaceOrderButtonTotal(totals) {
    if (!totals) {
        return;
    }

    ensurePlaceOrderTotalElement();
    $('.place-order-total').text(getAdjustedGrandTotalDisplay(totals));
}

/**
 * updates the totals summary
 * @param {Array} totals - the totals data
 */
function updateTotals(totals) {
    $('.shipping-total-cost').text(totals.totalShippingCost);
    $('.tax-total').text(totals.totalTax);
    $('.sub-total').text(totals.subTotal);
    // grandTotalAfterGCApplied from TotalsModel already subtracts gift cards and store credit
    var adjustedGrandTotal = getAdjustedGrandTotalDisplay(totals);
    $('.grand-total-sum').text(adjustedGrandTotal);
    updatePlaceOrderButtonTotal(totals);

    if (totals.appliedStoreCreditTotal && totals.appliedStoreCreditTotal.value > 0) {
        $('.store-credit-item')
            .attr('data-store-credit-applied', totals.appliedStoreCreditTotal.value)
            .removeClass('d-none');
        $('.store-credit-total').text('- ' + totals.appliedStoreCreditTotal.formatted);
    } else if (typeof totals.appliedStoreCreditTotal !== 'undefined'
        && totals.appliedStoreCreditTotal
        && totals.appliedStoreCreditTotal.value === 0) {
        $('.store-credit-item').addClass('d-none').attr('data-store-credit-applied', '0');
        $('.store-credit-total').empty();
    }

    if (totals.appliedGCTotal && totals.appliedGCTotal.value > 0) {
        $('.gift-card-total-item').removeClass('d-none');
        $('.giftcard-total').text('- ' + totals.appliedGCTotal.formatted);
    } else if (totals.appliedGCTotal && totals.appliedGCTotal.value === 0) {
        $('.gift-card-total-item').addClass('d-none');
        $('.giftcard-total').empty();
    }

    if (totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').text('- ' +
            totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }
}

/**
 * updates the order product shipping summary for an order model
 * @param {Object} order - the order model
 */
function updateOrderProductSummaryInformation(order) {
    var $productSummary = $('<div />');
    order.shipping.forEach(function (shipping) {
        shipping.productLineItems.items.forEach(function (lineItem) {
            var pli = $('[data-product-line-item=' + lineItem.UUID + ']');
            $productSummary.append(pli);
        });

        var address = shipping.shippingAddress || {};
        var selectedMethod = shipping.selectedShippingMethod;

        var nameLine = address.firstName ? address.firstName + ' ' : '';
        if (address.lastName) nameLine += address.lastName;

        var address1Line = address.address1;
        var address2Line = address.address2;

        var phoneLine = address.phone;

        var shippingCost = selectedMethod ? selectedMethod.shippingCost : '';
        var methodNameLine = selectedMethod ? selectedMethod.displayName : '';
        var methodArrivalTime = selectedMethod && selectedMethod.estimatedArrivalTime
            ? '( ' + selectedMethod.estimatedArrivalTime + ' )'
            : '';

        var tmpl = $('#pli-shipping-summary-template').clone();

        if (shipping.productLineItems.items && shipping.productLineItems.items.length > 1) {
            $('h5 > span').text(' - ' + shipping.productLineItems.items.length + ' '
                + order.resources.items);
        } else {
            $('h5 > span').text('');
        }

        var stateRequiredAttr = $('#shippingState').attr('required');
        var isRequired = stateRequiredAttr !== undefined && stateRequiredAttr !== false;
        var stateExists = (shipping.shippingAddress && shipping.shippingAddress.stateCode)
            ? shipping.shippingAddress.stateCode
            : false;
        var stateBoolean = false;
        if ((isRequired && stateExists) || (!isRequired)) {
            stateBoolean = true;
        }

        var shippingForm = $('.multi-shipping input[name="shipmentUUID"][value="' + shipping.UUID + '"]').parent();

        if (shipping.shippingAddress
            && shipping.shippingAddress.firstName
            && shipping.shippingAddress.address1
            && shipping.shippingAddress.city
            && stateBoolean
            && shipping.shippingAddress.countryCode
            && (shipping.shippingAddress.phone || shipping.productLineItems.items[0].fromStoreId)) {
            $('.ship-to-name', tmpl).text(nameLine);
            $('.ship-to-address1', tmpl).text(address1Line);
            $('.ship-to-address2', tmpl).text(address2Line);
            $('.ship-to-city', tmpl).text(address.city);
            if (address.stateCode) {
                $('.ship-to-st', tmpl).text(address.stateCode);
            }
            $('.ship-to-zip', tmpl).text(address.postalCode);
            $('.ship-to-phone', tmpl).text(phoneLine);

            if (!address2Line) {
                $('.ship-to-address2', tmpl).hide();
            }

            if (!phoneLine) {
                $('.ship-to-phone', tmpl).hide();
            }

            shippingForm.find('.ship-to-message').text('');
        } else {
            shippingForm.find('.ship-to-message').text(order.resources.addressIncomplete);
        }

        if (shipping.isGift) {
            $('.gift-message-summary', tmpl).text(shipping.giftMessage);
        } else {
            $('.gift-summary', tmpl).addClass('d-none');
        }

        // checking h5 title shipping to or pickup
        var $shippingAddressLabel = $('.shipping-header-text', tmpl);
        $('body').trigger('shipping:updateAddressLabelText',
            { selectedShippingMethod: selectedMethod, resources: order.resources, shippingAddressLabel: $shippingAddressLabel });

        if (shipping.selectedShippingMethod) {
            $('.display-name', tmpl).text(methodNameLine);
            $('.text-small', tmpl).text(selectedMethod.descriptionCustom);
            $('.arrival-time', tmpl).text(methodArrivalTime);
            $('.price', tmpl).text(shippingCost);
        }

        var $shippingSummary = $('<div class="multi-shipping" data-shipment-summary="'
            + shipping.UUID + '" />');
        $shippingSummary.html(tmpl.html());
        $productSummary.append($shippingSummary);
    });

    $('.product-summary-block').html($productSummary.html());

    // Also update the line item prices, as they might have been altered
    $('.grand-total-price').text(order.totals.subTotal);
    order.items.items.forEach(function (item) {
        if (item.lineItemTotalWithoutEmbroidery && item.lineItemTotalWithoutEmbroidery.formattedValue) {
            $('.line-item-total-price-amount .item-total-' + item.UUID).empty().append(item.lineItemTotalWithoutEmbroidery.formattedValue);
        }
    });
}

module.exports = {
    updateTotals: updateTotals,
    updatePlaceOrderButtonTotal: updatePlaceOrderButtonTotal,
    updateOrderProductSummaryInformation: updateOrderProductSummaryInformation
};
